import moment from 'moment/moment';
import React from 'react';
import { Col, Radio, Spin } from 'antd';

function SelectTimeControl({
  fisheryPublicId,
  availability,
  loading = false,
  selectedLakeId = null,
  arrivalTime,
  onChangeArrival = () => {},
  departureTime,
  onChangeDeparture = () => {},
  arrivalDate = null,
  departureDate = null,
}) {
  const HideTimeFishery = process.env.REACT_APP_FISHERY_HIDE_TIME_ID;
  const wadmillFishery = process.env.REACT_APP_FISHERY_TIME_ID;
  const a12Fishery = process.env.REACT_APP_FISHERY_A12_ID;
  const elphicksLake1 = process.env.REACT_APP_ELPHICKS_NORTH_LAKE;
  const elphicksLake2 = process.env.REACT_APP_ELPHICKS_WEST_END;
  const elphicksLake3 = process.env.REACT_APP_ELPHICKS_PULLENS;
  let hasNightArrival = availability?.arrival?.length;

  if (
    selectedLakeId === elphicksLake1 ||
    selectedLakeId === elphicksLake2 ||
    selectedLakeId === elphicksLake3
  ) {
    hasNightArrival = 1;
    // when it is 1 the options will have only 1 option will be displayed
  } else {
  }
  const handleTimeLabel = (hour) => {
    // Parse hour string
    const [timeStr, amPmLabel] = hour.split(' ');
    const [hourNumStr, minutesNumStr] = [...timeStr.split(':'), '00']; // Uses 00 as minutes default for values of shape "07" compared to "07:30" or "07:00"
    let hourNum = parseInt(hourNumStr);
    // Only show AM/PM
    if (fisheryPublicId === HideTimeFishery) {
      return amPmLabel;
    }

    if (
      selectedLakeId === '72121c5f-52c6-4123-a32c-71fa2f6c17dd' &&
      moment(arrivalDate).format('DD-MM-YYYY') !==
        moment(departureDate).format('DD-MM-YYYY')
    ) {
      const departureHour = availability?.departure?.[1]?.hour;

      if (departureHour === '04 PM') {
        let timeLabel = '';
        if (hour === '07 AM') {
          timeLabel = '7am - 12pm';
        } else if (hour === '01 PM') {
          timeLabel = `1pm - 4pm`;
        } else if (hour === '12 PM') {
          timeLabel = '7am - 12pm';
        } else if (hour === '04 PM') {
          timeLabel = '1pm - 4pm';
        } else {
          timeLabel = hour;
        }
        return timeLabel;
      }

      if (departureHour === '07 PM') {
        let timeLabel = '';
        if (hour === '07 AM') {
          timeLabel = '7am - 12pm';
        } else if (hour === '01 PM') {
          timeLabel = `1pm - 7pm`;
        } else if (hour === '12 PM') {
          timeLabel = '7am - 12pm';
        } else if (hour === '07 PM') {
          timeLabel = '1pm - 7pm';
        } else {
          timeLabel = hour;
        }
        return timeLabel;
      }
    }
    if (
      fisheryPublicId === wadmillFishery &&
      moment(arrivalDate).format('DD-MM-YYYY') !==
        moment(departureDate).format('DD-MM-YYYY')
    ) {
      // Special case for Wadmill Fishery
      let timeLabel = '';
      if (hour === '07 AM') {
        timeLabel = '7am - 12pm';
      } else if (hour === '01 PM') {
        timeLabel = '1pm - 5pm';
      } else if (hour === '12 PM') {
        timeLabel = '7am - 12pm';
      } else if (hour === '06 PM') {
        timeLabel = '1pm - 5pm';
      } else {
        timeLabel = hour;
      }
      return timeLabel;
    }

    if (
      fisheryPublicId === wadmillFishery &&
      moment(arrivalDate).format('DD-MM-YYYY') ===
        moment(departureDate).format('DD-MM-YYYY')
    ) {
      if (hour === '06 PM') {
        return '05 PM';
      }
    }
    // Standard format

    return hour;
  };

  const arrivalDateString = moment(arrivalDate).format('ddd Do MMMM');
  const departureDateString = moment(departureDate).format('ddd Do MMMM');

  return (
    <Col className='InputFromTo time-section mg-bottom-15 pd-0'>
      {loading && (
        <div id='booking-time-loading'>
          <Spin />
        </div>
      )}
      <div className='display-add-booking-time'>
        <div>
          <p className='booking-select-time'>
            Arrival{' '}
            {moment(arrivalDate).isValid() && (
              <p className={'txt-single-line-ellipsis'}>
                ({arrivalDateString})
              </p>
            )}
          </p>
          <div>
            <Radio.Group
              onChange={(e) => onChangeArrival(e.target.value)}
              value={arrivalTime ? arrivalTime : ''}
              defaultValue={arrivalTime}
              buttonStyle='solid'
            >
              {availability
                ? availability.arrival.slice(0, hasNightArrival).map((item) => {
                    return item.is_available ? (
                      <Radio.Button value={item.arrival_ts} className='gLight'>
                        {handleTimeLabel(item.hour)}
                      </Radio.Button>
                    ) : (
                      <Radio.Button
                        value={item.arrival_ts}
                        disabled
                        className='gLight'
                      >
                        {handleTimeLabel(item.hour)}
                      </Radio.Button>
                    );
                  })
                : ''}
            </Radio.Group>
          </div>
        </div>
      </div>
      <div className='display-add-booking-time'>
        <div>
          <p className='booking-select-time'>
            Departure{' '}
            {moment(departureDate).isValid() && (
              <p className={'txt-single-line-ellipsis'}>
                ({departureDateString})
              </p>
            )}
          </p>
          <div>
            <Radio.Group
              onChange={(e) => onChangeDeparture(e.target.value)}
              defaultValue={departureTime}
              value={departureTime ? departureTime : ''}
              buttonStyle='solid'
            >
              {availability
                ? availability.departure.map((item) => {
                    return item.is_available ? (
                      <Radio.Button
                        value={item.departure_ts}
                        className='gLight'
                      >
                        {handleTimeLabel(item.hour)}
                      </Radio.Button>
                    ) : (
                      <Radio.Button
                        value={item.departure_ts}
                        disabled
                        className='gLight'
                      >
                        {handleTimeLabel(item.hour)}{' '}
                      </Radio.Button>
                    );
                  })
                : ''}
            </Radio.Group>
          </div>
        </div>
      </div>
    </Col>
  );
}

export default SelectTimeControl;
